import { SelectMulti, SelectMultiProps } from '@components/selectmulti';

import { FormFieldProps } from './types';
import { useFormField } from './use-form-field';

export type FormSelectMultiProps<T> = FormFieldProps<SelectMultiProps, T>;

export function FormSelectMulti<T>(props: FormSelectMultiProps<T>) {
  const defaultValue = props.defaultValue
    ? Array.isArray(props.defaultValue)
      ? props.defaultValue
      : [props.defaultValue]
    : [];

  const formFieldProps = useFormField({ ...props, defaultValue, valueType: 'select-multi' });

  return <SelectMulti {...props} {...formFieldProps} defaultValue={defaultValue} />;
}
